import BetoniRow from "./BetoniRow";
import { Button, Fade, Grid, Typography } from "@mui/material";

import { useKeikkaData } from "src/context/KeikkaDataContext";
import { useKeikkaBetoniData } from "src/context/KeikkaBetoniContext";
import { useNavData } from "src/context/navContext";

import MySkeleton from "src/components/layout/MySkeleton";
import { lazy, useState } from "react";
import LazyLoader from "src/components/layout/Progress/LazyLoader";

const ToimittajaSelectorForTyomaaModal = lazy(() =>
  import("src/components/toimittaja/ToimittajaSelectorForTyomaa/ToimittajaSelectorForTyomaaModal")
);

export default function BetoniRows() {
  const { keikkaData, doSetKeikkaData } = useKeikkaData();
  const { doSetStepId: setStepId } = useNavData();
  const { doSetKeikkaBetoniId } = useKeikkaBetoniData();
  const [toimittajaSelectorIsOpen, setToimittajaSelectorIsOpen] = useState(false);

  function handleBetoniKlikkaus(_thisBetoni) {
    doSetKeikkaBetoniId(_thisBetoni.keikkaBetoniId);
    setStepId(4);
  }
  const handleOpenBetoniSelector = () => {
    setToimittajaSelectorIsOpen(true);
  };

  return (
    <>
      <LazyLoader>
        <ToimittajaSelectorForTyomaaModal
          isOpen={toimittajaSelectorIsOpen}
          onClose={() => setToimittajaSelectorIsOpen(false)}
          doFindClosestSijaintiForKeikka={false}
        />
      </LazyLoader>
      <div aria-label="Muokkaa betonia">
        {/* {keikkaData?.betoniToimittaja?.asiakasId > 0 && ( */}
        <Button fullWidth onClick={handleOpenBetoniSelector} className="stepRow">
          <Grid container sx={{ width: "100%" }}>
            <Grid size={{ xs: 3 }} sx={{ textAlign: "right" }}>
              <Typography
                variant="h6"
                sx={{ paddingRight: "5px", transition: "all 1.3s ease-in-out" }}
                color="primary"
                noWrap
                className="fixPrint">
                Betoni:
              </Typography>
            </Grid>
            <Grid
              size={{ xs: 9 }}
              sx={{
                textAlign: "left",
              }}>
              {keikkaData.isLoading ? (
                <MySkeleton width="30%" height="35px" />
              ) : (
                <>
                  <Fade in={true} timeout={500} unmountOnExit>
                    <div
                      style={{
                        display: "flex",
                        gap: 12,
                        alignItems: "center",
                        paddingTop: "5px",
                      }}>
                      <Typography
                        variant="body"
                        color="primary"
                        className="fixPrint"
                        sx={{ transition: "all 1.3s ease-in-out" }}>
                        {keikkaData.betoniToimittaja?.asiakasNimi ||
                          "Betonitoimittajaa ei ole asetettu"}
                      </Typography>
                      {keikkaData.betoniToimittaja?.sijaintiMatkaM > 0 && (
                        <Typography
                          variant="body"
                          color="primary"
                          className="fixPrint transitionElement">
                          {keikkaData.betoniToimittaja.sijainti?.sijaintiNimi +
                            " " +
                            Math.round(keikkaData.betoniToimittaja.sijaintiMatkaM / 1000)}{" "}
                          km
                        </Typography>
                      )}
                    </div>
                  </Fade>
                </>
              )}
            </Grid>
          </Grid>
        </Button>
        {/* )} */}
        {keikkaData.betoni.map((_thisBetoni, index) => {
          return (
            <BetoniRow
              keikkaData={keikkaData}
              disabled={!keikkaData.auth.edit}
              key={_thisBetoni.keikkaBetoniId}
              keikkaBetoniId={_thisBetoni.keikkaBetoniId}
              onClick={(_thisBetoni) => handleBetoniKlikkaus(_thisBetoni)}
              showAcceptIcons={keikkaData.tila.keikkaTilaId == 3}
              setKeikkaData={doSetKeikkaData}
              aria-label="Muokkaa betonia"
              bIndex={index}
            />
          );
        })}
      </div>
    </>
  );
}
